module.exports = __webpack_public_path__ + "static/media/Chibueze_Kalu_CV-compressed.c173156e.pdf";